import Language from './Language';
import {Model} from '@vuex-orm/core';
import {getCode} from "@/lang";

export default class Country extends Model {
  static entity = 'countries';
  static defaults = 'countries';
  static primaryKey = 'code'

  static fields() {
    return {
      code: this.attr(null),
      phoneExtension: this.attr(null),
      alternativeSpellings: this.attr(null),
      name: this.string(''),
      numericCode: this.attr(null),
      names: this.attr(null),
      language: this.belongsTo(Language, 'language_id'), // TODO: check relation
    };
  }

  static apiConfig = {
    actions: {
      /* get prices, other data fetched in basic property call (accommodation instead of content API to get prices). */
      async fetch() {
        /* Variable for storing the API response */
        let response
        try {
          response = await this.get(`/staticdata/v2/countries/${getCode()}?getalternativespellings=false`)

          /* extract data from response */
          response = response.response.data

          /* Check the response for errors */
          if (!Array.isArray(response)) {
            throw TypeError(
              `Invalid response: get countries.\
              Expected Array, got ${typeof response}`
            )
          }
        } catch(e) {
          console.error(e)
          return []
        }

        return response
      }
    }
  }
}
